import React from 'react';

import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import api from '../../ducks/api';
import { claimCartOwnership, deleteCart, setCart } from '../../ducks/cart';

import Loader from '../../components/loader/Loader';
import withChannelFormatters from '../channelUtils/withChannelFormatters';
import ErrorPage from '../errorPage/ErrorPage';
import {
  analyticsAddToCart,
  analyticsClearEcommerce,
} from '../../middlewares/analytics/actions';

@withChannelFormatters
@connect(({ cart, auth }) => ({ cart, auth }))
export default class SpecialOrderPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {error: null};
  }

  componentDidMount() {
    const { params, dispatch, channelFormatters, auth, cart } = this.props;
    const { cartId, cartToken } = params;

    Promise.resolve()
      .then(() => {
        if (auth.token) {
          return dispatch(claimCartOwnership(cartId, cartToken));
        }

        return dispatch(api.get(`carts/by-id/${cartId}`, {cartToken}));
      })
      .then(specialOrderCartResponse => {
        if (cart && cart.tokenValue !== cartToken) {
          return dispatch(deleteCart(cart.id, cart.tokenValue))
            .then(() => specialOrderCartResponse);
        }

        return specialOrderCartResponse;
      })
      .then(specialOrderCartResponse => {
        dispatch(setCart(specialOrderCartResponse.content));
        dispatch(analyticsClearEcommerce());
        dispatch(analyticsAddToCart(specialOrderCartResponse.content));

        browserHistory.replace(channelFormatters.link('/checkout'))
      })
      .catch(err => {
        console.error('err', err);
        this.setState({ error: true })
      });
  }

  render() {
    const { error } = this.state;

    return error ? <ErrorPage type={ErrorPage.serviceUnavailable} /> : <Loader page />;
  }
}



// WEBPACK FOOTER //
// ./containers/specialOrderPage/SpecialOrderPage.js